import {
	CREDIT_FORM_NAMES,
} from "../constants";

const {
	cardholderName,
	cardNumber,
	cvv,
	expiration,
	zipCode,
} = CREDIT_FORM_NAMES;

const CARD_SEPARATOR_COUNT = 4;
const MAX_CARD_NUMBER_LENGTH = 19 + CARD_SEPARATOR_COUNT;

const EXP_SEPARATOR_COUNT = 3;
const MAX_EXP_LENGTH = 4 + EXP_SEPARATOR_COUNT;

const formatValueWithSeparator = ({
	value,
	splitOn,

	// matchOn,
	separator,
	maxLength = 100,
}) => value
	.replace(new RegExp(separator, "g"), "")
	.split(splitOn)
	.filter((piece) => !/^$|^\s+$/.test(piece))
	.join(separator)
	.substr(0, maxLength);

export const formatCardNumber = ({ newValue: value, oldValue }) => {
	if (/^(\d{4}\s+){1,4}$/.test(value) && !/\s\d$/.test(oldValue)) {
		return value.replace(/\s+/g, " ");
	}

	const formattedValue = formatValueWithSeparator({
		value,
		splitOn: /(\d{4})/,
		matchOn: /^\d{1,4}$/,
		separator: " ",
		maxLength: MAX_CARD_NUMBER_LENGTH,
	});

	if (/^$|^\d{1,4}(|(\s\d{1,4}){1,3})(|\s\d{1,3})$/.test(formattedValue)) {
		return formattedValue;
	}

	return oldValue;
};

export const formatCvv = ({ newValue, oldValue }) => {
	// empty or space check
	if (/^\s+/.test(newValue) || newValue === "") {
		return "";
	}

	if (/^\d{1,4}$/.test(newValue)) {
		return newValue;
	}

	return oldValue;
};

export const formatExpiration = ({ newValue: value, oldValue }) => {
	if (/^\d{2}\/$/.test(value)) {
		return `${oldValue} / `;
	}

	if (/^\d{2}\s\/$/.test(value)) {
		return oldValue.replace(" / ", "");
	}

	if (/^[2-9]$/.test(value)) {
		return `0${value} / `;
	}

	if (/^1(\s|\/)$/.test(value)) {
		return "01 / ";
	}

	if (/^1[3-9]$/.test(value)) {
		return `01 / ${value.substr(1)}`;
	}

	if (/^[1-9](|\s)\/(|\s)\d{1,2}$/.test(value)) {
		return `0${value.split(/\s\/\s|\//).join(" / ")}`;
	}

	if (/^[01][1-9](|\s)\/(|\s)\d{1,2}$/.test(value)) {
		return value.split(/\s\/\s|\//).join(" / ");
	}

	const formattedValue = formatValueWithSeparator({
		value,
		splitOn: /(\d{2})/,
		separator: " / ",
		maxLength: MAX_EXP_LENGTH,
	});

	if (/^$|^([01]|0[1-9]|1[0-2])(|\s\/\s[1-9](|[0-9]))$/.test(formattedValue)) {
		return formattedValue;
	}

	return oldValue;
};

export const formatZipCode = ({ newValue, oldValue }) => {
	// empty or space check
	if (/^\s+/.test(newValue) || newValue === "") {
		return "";
	}

	if (/^[0-9A-Za-z]+$/.test(newValue)) {
		return newValue;
	}

	return oldValue;
};

export const formatValue = ({ name, newValue, oldValue }) => {
	switch (name) {
		case cardholderName: {
			return newValue;
		}

		case cardNumber: {
			return formatCardNumber({
				newValue,
				oldValue,
			});
		}

		case cvv: {
			return formatCvv({
				newValue,
				oldValue,
			});
		}

		case expiration: {
			return formatExpiration({
				newValue,
				oldValue,
			});
		}

		case zipCode: {
			return formatZipCode({
				newValue,
				oldValue,
			});
		}

		default: {
			throw new Error(`Trying to format ${name}, which doesn't exist.`);
		}
	}
};



// WEBPACK FOOTER //
// ./src/shared/payment/helpers/format-value.js